import { render } from "./customTag.vue?vue&type=template&id=ae32b91c&scoped=true"
import script from "./customTag.vue?vue&type=script&lang=js"
export * from "./customTag.vue?vue&type=script&lang=js"

import "./customTag.vue?vue&type=style&index=0&id=ae32b91c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae32b91c"

export default script